<template lang="html">
  <bimPopup
    :value="value"
    @input="$emit('input', false)"
    title="Пригласить сотрудника"
    width="100%"
  >
    <div class="invite__popup" :class="{loading: isLoading}">
      <bim-input
        dadataType="email"
        v-model="form.user.email"
        :formModel="_self"
        formKey="form.user.email"
        placeholder="Email сотрудника"
        class="mb-6"
        @blur="searchEmployee"
      />

      <div class="not__found__user" v-if="findedEmployee">
        Пользователь уже в компании
      </div>
      <div class="user__fullname" v-if="userFullName">
        {{userFullName}}
      </div>

      <bim-input
        v-model="form.position"
        :formModel="_self"
        formKey="form.position"
        placeholder="Должность"
        class="mb-6"
      />

      <div class="module__wrp mb-6" v-for="module in modules" :key="module.name">
        <bim-checkbox
          :label="module.title"
          :id="module.name"
          :value="selectedModules[module.name]"
          @input="onCheckboxClicked(module.name)"
        />

        <div class="roles__wrp" v-if="selectedModules[module.name]">
          <div
            class="roles__block"
            v-for="role in module.permissions"
            :key="role.name"
            @click="innerCheckboxClicked(module.name, role.name)"
          >
            <div class="d-flex">
              <bim-checkbox
                size="s"
                @input="innerCheckboxClicked(module.name, role.name)"
                :id="`${module.name}${role.name}`"
                :value="roles[module.name] && roles[module.name].includes(role.name)"
                :name="role.name"
              >
                <div class="flex-grow-1 module__desc">
                  <bim-text type=main bold>{{role.title}}</bim-text>
                  <bim-text type=medium>{{role.description}}</bim-text>
                </div>
              </bim-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="module__wrp mb-6" v-if="isAdmin">
        <bim-checkbox
          label="Владелец компании"
          v-model="form.owner"
        />
      </div>

      <bim-button
        :label="form.id ? 'Обновить' : 'Пригласить'"
        :disabled="findedEmployee"
        @click="inviteClicked"
      />
    </div>
  </bimPopup>
</template>

<script>
// /* eslint-disable */
import { forEach } from 'lodash'

import bimPopup from '../bimPopup/bimPopup'
import bimButton from '../../form/bimButton/bimButton'
import bimCheckbox from '../../form/bimCheckbox/bimCheckbox'
import bimInput from '../../form/bimInput/bimInput'
import bimText from '../../text/bimText/bimText'

const formFullName = user => {
  const { lastName, firstName, fatherName } = user
  return `${lastName} ${firstName} ${fatherName}`
    .trim()
    .replace(/\s{2}/g, '')
}

const model = (data = {}) => {
  const init = {
    user: {
      email: ''
    },
    position: ''
  }

  return Object.assign({}, init, data)
}

const defaultForm = {
  position: 'Сотрудник'
}

export default {
  name: 'bimInvitePopup',
  components: {
    bimPopup,
    bimButton,
    bimCheckbox,
    bimInput,
    bimText
  },
  props: {
    /**
     * v-model
     */
    value: Boolean,
    /**
     * ID компании обновляемого пользователя
     */
    companyId: {
      type: String
    },
    /**
     * Контекст пользователя если обновляем права
     */
    userContext: {
      type: Object
    },
    /**
     * Префикс для апи запросов
     */
    apiPrefix: {
      type: String,
      default: '/api'
    },
    isAdmin: {
      type: Boolean,
    }
  },
  data () {
    return {
      isLoading: false,
      findedEmployee: false,
      companyPermissions: [],
      userFullName: '',
      userModel: null,
      form: model(this.userContext || defaultForm),
      selectedModules: {}, // включенные модули
      roles: {}, // роли доступа
      oldUserPermissions: [], // текущие права пользователя на сервере
      permissions: [],
    }
  },
  watch: {
    'form.user.email' () {
      this.findedEmployee = false
    },
    userContext: {
      deep: true,
      handler (context) {
        if (!context) return
        this.form = model(context)
        this.fetchContext(context)
      }
    },
    value (show) {
      if (show) {
        this.form = model(this.userContext || defaultForm)
      } else {
        this.form = model({})
        this.oldUserPermissions = []
        this.selectedModules = {}
        this.roles = {}

        for (const key in this.$v2.blurredFields) {
          this.$v2.blurredFields[key] = false
        }
      }
    }
  },
  async mounted () {
    this.companyPermissions = await this.getCompanyPermissions()

    if (!this.permissions.length) {
      await this.fetchPermissions()
    }

    if (this.isAdmin) {
      this.fetchContext()
    }
  },
  computed: {
    isUpdateContext () {
      return !!this.form.id
    },
    formValidation () {
      return {
        'form.user.email': ['required', 'email'],
        'form.position': ['required']
      }
    },
    modules () {
      const companyPermissions = this.companyPermissions.map(p => p.name)
      return this.permissions.filter(p => companyPermissions.includes(p.name))
    },
  },
  methods: {
    fetchPermissions () {
      return fetch(
        `${this.apiPrefix}/passport/companies/permissions`
      )
        .then(r => r.json())
        .then(permissions => {
          this.permissions = permissions
        })
    },
    async searchEmployee () {
      if (!this.$v2.validForm) {
        return
      }

      this.findedEmployee = false
      this.userFullName = ''
      this.userModel = null

      try {
        const url = this.isAdmin
          ? `${this.apiPrefix}/passport/admin/users/`
          : `${this.apiPrefix}/passport/companies/${this.companyId}/employees`

        const users = await fetch(`${url}?email=${this.form.user.email}`)
          .then(r => r.json())
          .then(r => r.items)

        if (this.isAdmin && users.length) {
          this.userFullName = formFullName(users[0])
          this.userModel = users[0]
          this.form.user.id = users[0].id
        } else {
          const { email } = this.form.user
          const employee = users.find(({ user }) => {
            return user && user.email === email
          })

          if (employee && employee.invitationStatus !== 'CANCELLED') {
            this.findedEmployee = true
          }
        }

      } catch (e) {
        console.error(e)
      }
    },

    onCheckboxClicked (key) {
      const val = this.selectedModules[key]
      this.$set(this.selectedModules, key, !val)
      this.$v2.validateForm()
    },

    innerCheckboxClicked (key, value) {
      if (this.roles[key]) {
        const index = this.roles[key].indexOf(value)

        if (index >= 0) {
          this.roles[key].splice(index, 1)
        } else {
          this.roles[key].push(value)
        }
      } else {
        this.$set(this.roles, key, [value])
      }
    },

    async inviteClicked () {
      if (!this.$v2.forceValidateForm()) {
        return
      }

      this.isLoading = true

      await this.searchEmployee()
      if (this.findedEmployee) {
        this.isLoading = false
        return
      }

      const companyId = this.companyId
      const data = {
        ...this.form,
        permissions: this.getPermissions(),
      }

      if (!this.isAdmin) {
        data.employee = Object.assign({}, data.user)
        delete data.user
      }

      const fetchParams = {
        method: '',
        url: ''
      }

      if (!this.isAdmin) {
        /* ЛК добавление пользователя */
        fetchParams.url = `${this.apiPrefix}/passport/companies/${companyId}/employees`
        fetchParams.method = 'POST'
      } else if (this.isUpdateContext) {
        /* Админка обновление пользователя */
        fetchParams.url = `${this.apiPrefix}/passport/admin/companies/${companyId}/employees/${data.id}`
        fetchParams.method = 'PUT'
      } else {
        /* Админка добавление пользователя */
        fetchParams.url = `${this.apiPrefix}/passport/admin/companies/${companyId}/employments`
        fetchParams.method = 'POST'
      }

      await fetch(fetchParams.url, {
        method: fetchParams.method,
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
        .then(async res => {

          if (res.status >= 400) {
            throw new Error({
              status: res.status,
              statusText: res.statusText || ''
            })
          }

          if (this.isUpdateContext) {
            await this.savePermission(this.userModel.id, companyId)
          }

          /* Форма отправлена */
          this.$emit('sended')

          this.$emit('input', false)
          this.$toast(this.isUpdateContext ? 'Обновили данные' : 'Пригласили пользователя!')

          return res
        })
        .catch(e => {
          if (!e.status && !e.statusText) {
            this.$toast(
              `
                Не удалось пригласить сотрудника. <br>
                Учётная запись с указанным email не найдена.
              `,
              { title: 'Ошибка' }
            )
          } else {
            this.$toast(
              `Не удалось пригласить сотрудника [${e.status}] ${e.statusText}`,
              { title: 'Ошибка' }
            )
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    async getCompanyPermissions () {
      const url = this.isAdmin
      ? `${this.apiPrefix}/passport/admin/companies/${this.companyId}/permissions`
      : `${this.apiPrefix}/passport/companies/${this.companyId}/permissions`

      return fetch(url)
        .then(r => r.json())
    },

    async fetchContext (user) {
      this.isLoading = true
      const employee = this.userContext || user

      try {
        const companyPerms = await this.getEmployeePermissions()

        if (employee) {
          const employeeContext = await fetch(
            `${this.apiPrefix}/passport/admin/companies/${this.companyId}/employees/${employee.id}`
          )
            .then(r => r.json())

          this.userModel = employeeContext.user
          this.userFullName = formFullName(this.userModel)
        }

        /* сброс разрешений */
        this.oldUserPermissions = []

        forEach(companyPerms, perm => {
          if (employee) {
            this.$set(this.selectedModules, perm.name, true)
            this.$set(this.roles, perm.name, perm.permissions)
          } else {
            this.$set(this.roles, perm.name, [])
          }

          this.oldUserPermissions.push({
            name: perm.name,
            permissions: [].concat(perm.permissions)
          })
        })
      } catch (e) {
        console.error('fetchContext', e)
      } finally {
        this.isLoading = false
      }
    },

    async getEmployeePermissions () {
      const companyId = this.companyId
      let companyPerms

      try {
        if (this.isAdmin) {
          const employeeId = this.userContext && this.userContext.user.id
          if (employeeId) {
            const perms = await fetch(
              `${this.apiPrefix}/passport/admin/users/${employeeId}/permissions`
            )
              .then(r => r.json())

            companyPerms = (
              perms
                .filter(perm => perm.companyId === companyId)
                .map(perm => perm.module)
            )
          } else {
            companyPerms = await fetch(
              `${this.apiPrefix}/passport/admin/companies/${companyId}/permissions`
            )
              .then(r => r.json())
          }
        } else {
          companyPerms = await fetch(
            `${this.apiPrefix}/passport/companies/${companyId}/permissions`
          )
            .then(r => r.json())
        }
      } catch (error) {
        companyPerms = []
        console.error(error)
      }

      return companyPerms
    },

    async savePermission (userId, companyId) {

      const changePermission = (method, context) => fetch(
        `${this.apiPrefix}/passport/admin/users/${userId}/permissions`,
        {
          method,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(context)
        }
      )

      // Удаление текущих разрешений
      for (const module of this.oldUserPermissions) {
        await changePermission('DELETE', {
          module,
          userId,
          companyId
        })
      }

      // Установка разрешений
      for (const module of this.getPermissions()) {
        await changePermission('POST', {
          module,
          userId,
          companyId
        })
      }
    },

    getPermissions () {
      return Object
        .entries(this.roles)
        .filter(([name]) => this.selectedModules[name])
        .map(
          ([name, permissions]) => ({
            name,
            permissions: Array.isArray(permissions) ? permissions : [permissions]
          })
        )
    },
  }
}
</script>

<style lang="scss" scoped>
  .invite__popup {
    width: 550px;
    padding-top: 10px;
  }

  .not__found__user {
    background-color: #f65959;
    color: white;
    font-size: 14px;
    padding: 5px 12px;
    border-radius: 4px;
    margin-top: -6px;
    margin-bottom: 8px;
  }

  .user__fullname {
    background-color: #e5e5e5;
    font-size: 14px;
    padding: 5px 12px;
    border-radius: 4px;
    margin-top: -6px;
    margin-bottom: 8px;
  }

  .roles__block {
    margin-left: 20px;
    margin-top: 12px;
  }

  .module__desc {
    margin-left: 12px;
  }

  .roles__block:hover {
    cursor: pointer;
  }

  .loading {
    opacity: 0.5;
    pointer-events: none;
  }
</style>
